export const content = {
  format: 'Format',
  buchungsnummer: 'Buchungsnummer(n)',
  praesenzPendant: 'Präsenz-Pendant',
  onlinePendant: 'Online-Pendant',
} as const;
